import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const BarWrapper = styled(Box)(() => ({
  width: '100%'
}));

export const BarContainer = styled('div')<{ backgroundColor: string }>(
  ({ theme, backgroundColor }) => ({
    height: 7,
    backgroundColor: backgroundColor,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    borderRadius: 10,
    [theme.breakpoints.up('sm')]: {
      height: 8
    }
  })
);

interface BarFillerProps {
  width: number;
  backgroundColor?: string;
  visibility?: 'visible' | 'hidden';
}

export const BarFiller = styled('div')<BarFillerProps>(
  ({ theme, width, backgroundColor, visibility }) => ({
    height: '100%',
    width: `${width}%`,
    backgroundColor: backgroundColor ?? theme.palette.success.main,
    visibility: visibility,
    borderRadius: 'inherit',
    transition: 'width 1s ease-in-out'
  })
);

export const BarLabelsWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  '& > p': {
    fontWeight: 600
  }
}));
